import Box from '@mui/material/Box';
import MuiLink from '@mui/material/Link';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';

const BUTTON_LINK_RESET_SX = {
  background: 'none',
  border: 0,
  p: 0,
  cursor: 'pointer',
  font: 'inherit',
} as const;

const INLINE_LINK_SX = {
  textDecoration: 'none',
  '&:hover': { textDecoration: 'underline' },
} as const;

export interface IdentityCellProps {
  row: Record<string, unknown>;
  detailHref: string;
  accent: string;
  onOpen?: (row: Record<string, unknown>) => void;
}

export const IdCell: React.FC<IdentityCellProps & { nodeId: number }> = ({
  row,
  detailHref,
  accent,
  onOpen,
  nodeId,
}) => {
  if (onOpen) {
    return (
      <Box
        component="button"
        type="button"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          onOpen(row);
        }}
        sx={{
          ...BUTTON_LINK_RESET_SX,
          color: accent,
          fontWeight: 600,
          '&:hover': { textDecoration: 'underline' },
        }}
      >
        {String(nodeId)}
      </Box>
    );
  }
  return (
    <MuiLink
      component={RouterLink}
      to={detailHref}
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      sx={{ color: accent, fontWeight: 600, textDecoration: 'none' }}
    >
      {String(nodeId)}
    </MuiLink>
  );
};

export const NameCell: React.FC<IdentityCellProps & { value: string }> = ({
  row,
  detailHref,
  accent,
  onOpen,
  value,
}) => {
  if (onOpen) {
    return (
      <Box
        component="button"
        type="button"
        onClick={(e: React.MouseEvent) => {
          e.stopPropagation();
          onOpen(row);
        }}
        sx={{
          ...INLINE_LINK_SX,
          ...BUTTON_LINK_RESET_SX,
          color: accent,
          fontWeight: 500,
          textAlign: 'left',
        }}
      >
        {value}
      </Box>
    );
  }
  return (
    <MuiLink
      component={RouterLink}
      to={detailHref}
      onClick={(e: React.MouseEvent) => e.stopPropagation()}
      sx={{ ...INLINE_LINK_SX, color: accent, fontWeight: 500 }}
    >
      {value}
    </MuiLink>
  );
};
